import low from 'lowdb'
import LocalStorage from 'lowdb/adapters/LocalStorage'
import setting from '@/setting'
import { cloneDeep } from 'lodash'
import store from '@/store'

const db = low(new LocalStorage(`${setting.name}-${process.env.VUE_APP_VERSION}-${process.env.VUE_APP_BUILD_MODE}`))

/**
 * 转换路径并初始化
 */
function getConvertPath(path = '', user = true, defaultValue = '') {
  const convertPath = `${path || 'public'}.${user ? store.state.user.info.accountId || 'user-id' : 'user'}`
  if (db.get(convertPath).value() === undefined) {
    db.set(convertPath, defaultValue).write()
  }
  return convertPath
}

export const useDbUtil = {
  /**
   * 保存存储数据
   */
  set: (path = '', value = '', user = false) => {
    db.set(getConvertPath(path, user), value).write()
  },

  /**
   * 获取存储数据
   */
  get: (path = '', defaultValue = '', user = false) => {
    return cloneDeep(db.get(getConvertPath(path, user, defaultValue)).value())
  },

  /**
   * 清空存储数据
   */
  clear: (path = '', user = false) => {
    return db
      .get(getConvertPath(path, user))
      .remove()
      .write()
  }
}
